<template>
  <div id="login-page">
    <el-col :offset="8" :span="8">
      <el-row style="margin-top: 50px;">
        <img src="../assets/images/logitembus_logo_2.jpg" width="70%"/>
      </el-row>
      <div @keydown.enter="submitLogin">
        <el-row style="display: inline-flex; margin-top: 50px; width: 100%">
          <el-col :span="10">
            <div class="lbl-login">{{ $t('common.username') }}:</div>
          </el-col>
          <el-col :span="14">
            <input class="input-login" v-model="loginInfo.username" type="text"/>
          </el-col>
        </el-row>
        <el-row style="display: inline-flex; margin-top: 20px; width: 100%">
          <el-col :span="10">
            <div class="lbl-login">{{ $t('common.password') }}:</div>
          </el-col>
          <el-col :span="14">
            <input class="input-login" v-model="loginInfo.password" type="password"/>
          </el-col>
        </el-row>
        <!--<el-row style="display: inline-flex; margin-top: 20px; width: 100%">-->
          <!--<input type="checkbox" name="vehicle1" value="Bike"><span class="remember">Remember me</span>-->
        <!--</el-row>-->
        <el-row style="display: inline-flex; margin-top: 20px; width: 100%">
          <el-col :span="24">
            <el-button style="font-size: 20px; width: 60%" type="success" @click="submitLogin">{{ $t('common.login') }}</el-button>
          </el-col>
        </el-row>
        <el-row style="display: inline-flex; margin-top: 20px; width: 100%">
          <el-col :span="24" style="text-align: center; line-height: 42px; font-size: 20px; ">
            <a style="text-decoration: none" href="" @click="goForgot">{{ $t('common.forgot_password') }}</a>
          </el-col>
        </el-row>
      </div>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: "Login",
    components: {

    },
    data: function () {
      return {
        loginInfo: {
          password: '',
          username: ''
        },
        route: ''
      }
    },
    methods: {
      submitLogin: function () {
        let successCallback = (response) => {
          if (response.data.data.role === 2) {
            this.$router.push('/parent/select-bus')
          } else if (response.data.data.role === 3) {
            this.$router.push('/bus')
          }
        }
        let payload = {
          successCallback,
          login_data: this.loginInfo
        }
        this.$store.dispatch('login/adminLogin', payload)
      },
      goForgot (e) {
        e.preventDefault()
        this.$router.push('/forgot')
      }
    },
    computed: {
      ...mapState('login', ['adminLoggedInfo']),
    },
    watch: {
      route: {

      }
    }
  }
</script>

<style lang="scss">
  .lbl-login {
    text-align: left;
    font-size: 20px;
    line-height: 40px;
  }

  .input-login {
    height: 35px;
    width: 100%;
    font-size: 17px;
    padding: 7px;
    border-radius: 5px;
    border: 1px solid gainsboro;
  }

  #login-page input[type='checkbox'] {
    -webkit-appearance: none;
    width: 28px;
    height: 28px;
    background: white;
    border-radius: 5px;
    border: 2px solid #555;
  }

  #login-page input[type='checkbox']:checked {
    background-image: url("../assets/icon/done-icon.png");
    background-repeat: no-repeat;
    background-size: contain;
  }

  .remember {
    font-size: 18px;
    line-height: 34px;
    padding-left: 10px;
  }
</style>